import dayjs, { Dayjs } from 'dayjs';

const STORAGE_KEY = 'periverse.caseCartAssembly.selectedDate';

const isBrowser = () => typeof window !== 'undefined';

export const readStoredDate = (): Dayjs | null => {
  if (!isBrowser()) return null;

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = dayjs(raw);
    if (!parsed.isValid()) return null;
    return parsed.startOf('day');
  } catch (error) {
    console.warn('Failed to read stored case cart assembly date', error);
    return null;
  }
};

export const writeStoredDate = (date: Dayjs) => {
  if (!isBrowser()) return;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, date.toISOString());
  } catch (error) {
    console.warn('Failed to persist case cart assembly date', error);
  }
};

export const clearStoredDate = () => {
  if (!isBrowser()) return;

  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear stored case cart assembly date', error);
  }
};
